export enum DISPATCH_STATUS {
  IN_STUDY = 1,
  DELIVERED = 2,
  NOT_STUDIABLE = 3,
}

export const DISPATCH_STATUSES = [
  { value: DISPATCH_STATUS.IN_STUDY, displayName: 'en estudio' },
  { value: DISPATCH_STATUS.DELIVERED, displayName: 'entregado' },
  { value: DISPATCH_STATUS.NOT_STUDIABLE, displayName: 'no estudiable' },
];

export enum STUDY_STATUS {
  PRE_STUDIED = 1,
  SENT_TO_INFORM = 2,
  FINALIZED = 3,
  REPEATED_RUT = 4,
  ERROR = 5,
  SGL_PREVIOUSLY_REPORTED = 6,
  IN_STUDY = 7,
  DISPATCHED = 8,
  NOT_STUDIABLE = 9,
  DELIVERED = 10,
}

export const STUDY_STATUSES = [
  {
    value: STUDY_STATUS.PRE_STUDIED,
    displayName: 'pre-estudiado',
    editable: false,
  },
  {
    value: STUDY_STATUS.SENT_TO_INFORM,
    displayName: 'enviado a informar',
    editable: false,
  },
  { value: STUDY_STATUS.FINALIZED, displayName: 'finalizado', editable: true },
  {
    value: STUDY_STATUS.REPEATED_RUT,
    displayName: 'rut repetido',
    editable: false,
  },
  { value: STUDY_STATUS.ERROR, displayName: 'error', editable: false },
  {
    value: STUDY_STATUS.SGL_PREVIOUSLY_REPORTED,
    displayName: 'SGL previamente informado',
    editable: false,
  },
  { value: STUDY_STATUS.IN_STUDY, displayName: 'en estudio', editable: false },
  {
    value: STUDY_STATUS.DISPATCHED,
    displayName: 'despachado',
    editable: false,
  },
  {
    value: STUDY_STATUS.NOT_STUDIABLE,
    displayName: 'no estudiable',
    editable: false,
  },
  { value: STUDY_STATUS.DELIVERED, displayName: 'entregado', editable: false },
];
